import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "name",
    key: "name",
    dataIndex: "name",
    ellipsis: true,
    width: 100,
  },
];

export default function () {

  return (
    <SimpleTablePage
      resource="workActivity"
      columns={columns}
    />
  );
}
